import { render } from "./AdminUserCreate.vue?vue&type=template&id=60751456&scoped=true&ts=true&lang=pug"
import script from "./AdminUserCreate.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminUserCreate.vue?vue&type=script&lang=ts&setup=true"

import "./AdminUserCreate.vue?vue&type=style&index=0&id=60751456&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60751456"]])

export default __exports__